import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heuteIso, istUeberfaellig, type MeineAufgabe } from '@beholder/shared/module/aufgaben';
import { api } from '../../core/api';
import type { GlobalProps } from '../../core/modul';
import './stil.css';

const ZEIGEN = 3;

function merker(ich: GlobalProps['ich']) {
  return `beholder-aufgaben-hinweis-${ich.id}`;
}

function schonGezeigt(schluessel: string): boolean {
  try {
    return sessionStorage.getItem(schluessel) === '1';
  } catch {
    return false;
  }
}

function merken(schluessel: string) {
  try {
    sessionStorage.setItem(schluessel, '1');
  } catch {
    /* ohne Speicher erscheint der Hinweis eben beim nächsten Laden wieder */
  }
}

/**
 * Marc: Hinweis beim Anmelden auf heute fällige und überfällige eigene Aufgaben (projektübergreifend).
 * Einmal pro Sitzung, dezent unten links, wegklickbar. Keine Mails.
 */
export function Hinweis({ ich }: GlobalProps) {
  const schluessel = merker(ich);
  const [liste, setListe] = useState<MeineAufgabe[] | null>(null);
  const [offen, setOffen] = useState(false);

  useEffect(() => {
    if (schonGezeigt(schluessel)) return;
    let aktiv = true;
    api
      .get<MeineAufgabe[]>('/api/modul/aufgaben/meine')
      .then((l) => {
        if (!aktiv) return;
        const heute = heuteIso();
        const wichtig = l.filter((a) => a.faellig && a.faellig <= heute);
        if (!wichtig.length) return;
        merken(schluessel);
        setListe(wichtig);
        setOffen(true);
      })
      .catch(() => {
        /* Hinweis ist nur eine Hilfe – bei Fehlern einfach nichts zeigen */
      });
    return () => {
      aktiv = false;
    };
  }, [schluessel]);

  if (!offen || !liste) return null;
  const heute = heuteIso();
  const ueber = liste.filter((a) => istUeberfaellig(a, heute));
  const heuteFaellig = liste.filter((a) => a.faellig === heute);
  const zu = () => setOffen(false);

  const gruppe = (titel: string, l: MeineAufgabe[], klasse: string) =>
    l.length > 0 && (
      <p className={`auf-hinweis-zeile ${klasse}`}>
        <strong>{titel}:</strong>{' '}
        {l.slice(0, ZEIGEN).map((a, i) => (
          <span key={a.id}>
            {i > 0 && ', '}
            <Link to={`/p/${a.projektId}/aufgaben/${a.id}`} onClick={zu} title={`${a.titel} · ${a.projektName}`}>
              {a.titel}
            </Link>
          </span>
        ))}
        {l.length > ZEIGEN && (
          <>
            {' '}
            <Link to="/" onClick={zu} className="leise">
              und {l.length - ZEIGEN} weitere
            </Link>
          </>
        )}
      </p>
    );

  return (
    <aside className="auf-hinweis" role="status" aria-label="Fällige Aufgaben">
      <div className="auf-hinweis-text">
        {gruppe('Heute fällig', heuteFaellig, '')}
        {gruppe('Überfällig', ueber, 'auf-text-ueber')}
      </div>
      <button type="button" className="knopf knopf-leise auf-hinweis-zu" onClick={zu} aria-label="Hinweis schließen" title="Schließen">
        ×
      </button>
    </aside>
  );
}
